<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">血压数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 20px;min-height: auto;">
        <template>
          <el-table v-loading="tableLoading" :data="tableData" height="300" border>

            <el-table-column prop="createTime" :formatter="getMeasurementDate" label="测量时间"></el-table-column>
            <el-table-column prop="gaoYa" label="高压(mmHg)"></el-table-column>
            <el-table-column prop="diYa" label="低压(mmHg)"></el-table-column>
            <el-table-column prop="maiBo" label="脉搏(分)"></el-table-column>

          </el-table>
          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>


  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "LXXueYaJiDataPage",
  data() {
    return {
      userCode: '',
      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

    }
  },
  components: {

  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getXueYaData();
    },
    closeSelf() {
      this.$emit("closeLXXueYaJiDataPage");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getXueYaData();
    },
    getMeasurementDate(row){
      return timefilters(row.createTime)
    },
    getIrregularHeartbeat(row){
      if(row.irregularHeartbeat==='true'){
        return '是'
      }else {
        return '否'
      }
    },
    getMovementError(row){
      if(row.movementError==='true'){
        return '是'
      }else {
        return '否'
      }
    },
    getXueYaData(){


      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);


      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "XueYaJi/PageForUser",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          startTime:start,
          endTime:end,
          deviceType:'AiAoLe',
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems=response.data.data.pageInfo.total
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },




  }


}

</script>

<style lang="scss" scoped>

</style>